import { render, staticRenderFns } from "./FeedbackModalDialog.vue?vue&type=template&id=eeea1956&"
import script from "./FeedbackModalDialog.vue?vue&type=script&lang=ts&"
export * from "./FeedbackModalDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeea1956')) {
      api.createRecord('eeea1956', component.options)
    } else {
      api.reload('eeea1956', component.options)
    }
    module.hot.accept("./FeedbackModalDialog.vue?vue&type=template&id=eeea1956&", function () {
      api.rerender('eeea1956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/vue/FeedbackModalDialog.vue"
export default component.exports